import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, Redirect, matchPath, withRouter} from 'react-router-dom';
import actions from './search.actions';
import SearchUserTypeSelector from './SearchUserTypeSelector';

import './CompactSearch.css';

export class CompactSearch extends Component {
	constructor() {
		super();

		this.state = {
			redirect: false,
			searchFocused: false
		};

		this.startSearch = e => {
			if (!this.props.query) {
				this.props.search();
				e.preventDefault();
				return;
			}
		};

		this.handleKeyPress = event => {
			if (event.key === 'Enter') {
				this.props.search();
				this.setState({redirect: true});
				this.input.blur();
			}
		};

		this.setSearchProvider = () => {
			if (this.props.query) {
				this.props.setSearchFor('provider');
				this.setState({redirect: true});
			}
		};
		this.setSearchCommunity = () => {
			if (this.props.query) {
				this.props.setSearchFor('community');
				this.setState({redirect: true});
			}
		};
		this.setSearchUser = () => {
			if (this.props.query) {
				this.props.setSearchFor('user');
				this.setState({redirect: true});
			}
		};
		this.setSearchFocus = () => {
			this.setState({searchFocused: true});
		};
		this.setSearchBlur = () => {
			// Delayed blur to allow for clicking in dropdown
			setTimeout(() => {
				this.setState({searchFocused: false});
				if (this.props.onBlur) this.props.onBlur();
			}, 200);
		};
	}

	componentDidMount() {
		// Allow searchFor override, which we will set upon rendering this component.
		// E.g. Search for community-only use of the component
		if (this.props.searchForOverride) {
			this.props.setSearchForOnly(this.props.searchFor);
		}
	}

	componentDidUpdate() {
		if (this.state.redirect) {
			this.setState({redirect: false}); // Redirect should only execute once
		}
	}

	componentWillReceiveProps(nextProps) {
		// IF route changes and the new page is not search, clear the existing query if there is one
		if (
			nextProps.query &&
			this.props.path !== nextProps.path &&
			!matchPath(nextProps.path, {path: '/search/'})
		) {
			this.props.clearSearch();
		}
	}

	render() {
		const {
			query,
			setQuery,
			className,
			isOpen,
			refGetter,
			enableUserTypeSelector = true,
			radii = true,
			placeholder = 'Search by name, type, location, ...'
		} = this.props;

		return (
			<div
				className={`CompactSearch ${className || ''} ${isOpen ? 'open' : ''} ${
					this.state.searchFocused && query && query.length ? 'dropped' : ''
				}`}>
				{this.state.redirect && <Redirect push to={`/search/${query || ''}`} />}
				<form
					action="."
					onSubmit={e => {
						e.preventDefault();
					}}>
					<input
						ref={el => {
							this.input = el;
							refGetter && refGetter(el);
						}}
						type="search"
						placeholder={placeholder}
						value={query}
						onFocus={this.setSearchFocus}
						onBlur={this.setSearchBlur}
						onChange={setQuery}
						onKeyPress={this.handleKeyPress}
					/>
				</form>
				<Link onClick={this.startSearch} to={`/search/${query || ''}`}>
					<span className="icon icon-search" />
				</Link>
				{enableUserTypeSelector && (
					<div className="CompactSearch-dropdown">
						<SearchUserTypeSelector
							compact={false}
							setSearchProvider={this.setSearchProvider}
							setSearchCommunity={this.setSearchCommunity}
							setSearchUser={this.setSearchUser}
							radii={radii}
						/>
					</div>
				)}
			</div>
		);
	}
}

const ConnectedCompactSearch = withRouter(
	connect(
		(state, ownProps) => ({
			path: state.router.location.pathname,
			query: state.search.query,
			searchFor: state.search.searchFor,
			searchForOverride: !!ownProps.searchFor,
			suggestion:
				state.suggestions.items[state.suggestions.current] &&
				state.suggestions.items[state.suggestions.current].profession,
			isOpen: state.search.isCompactSearchOpen
		}),
		(dispatch, ownProps) => ({
			setQuery: e => dispatch(actions.searchSetQuery(e.target.value)),
			setSearchFor: searchFor => {
				dispatch(actions.searchFor(searchFor));
				dispatch(actions.performSearch());
			},
			search: () => dispatch(actions.performSearch()),
			setSearchForOnly: searchFor => {
				dispatch(actions.searchFor(searchFor));
			},
			clearSearch: () => dispatch(actions.searchSetQuery(''))
		})
	)(CompactSearch)
);

export default ConnectedCompactSearch;



// WEBPACK FOOTER //
// ./src/search/CompactSearch.js